/**
 * Shared appointment status helpers for badge color and display text.
 */
import {
  COMPLETED_APPOINTMENT_SESSION_STATUSES,
  formatFhirOrLegacyAppointmentStatus,
} from './appointmentFhirStatusOptions';

const APPOINTMENT_STATUS_COLORS: Record<string, string> = {
  proposed: 'violet',
  booked: 'blue',
  arrived: 'blue',
  'checked-in': 'blue',
  pending: 'blue',
  waitlist: 'blue',
  fulfilled: 'green',
  cancelled: 'red',
  noshow: 'red',
  'no-show': 'red',
  'entered-in-error': 'red',
  requested: 'violet',
  scheduled: 'blue',
  completed: 'green',
  'no_show': 'red',
  // legacy
  show: 'green',
};

function normalizeStatusKey(s: string): string {
  return s.toLowerCase().replace(/[\s_]+/g, '-');
}

export function getAppointmentStatusBadgeColor(status: string | undefined): string {
  if (!status) return 'blue';
  if (APPOINTMENT_STATUS_COLORS[status] !== undefined) {
    return APPOINTMENT_STATUS_COLORS[status]!;
  }
  return APPOINTMENT_STATUS_COLORS[normalizeStatusKey(status)] ?? 'gray';
}

export function formatAppointmentStatus(status: string | undefined): string {
  if (!status) return '—';
  return formatFhirOrLegacyAppointmentStatus(status, '—');
}

/**
 * "Terminal" or closed-out appointment session outcomes for workflow (e.g. hide Join Call).
 */
export const COMPLETED_STATUSES = COMPLETED_APPOINTMENT_SESSION_STATUSES;
